import { createAction, props } from '@ngrx/store';
import { GeneratedPdfModel } from '../../models/pdf/generated-pdf.model';
import { GeneratePdfPostModel } from '../../models/pdf/generate-pdf-post.model';

// Trigger a Pdf (e.g. PDF) generation
export const generatePdf = createAction(
  '[Pdf] Generate Pdf',
  props<{ payload: GeneratePdfPostModel }>(),
);

// When a Pdf has been successfully generated
export const pdfGenerated = createAction(
  '[Pdf] Pdf Generated',
  props<{ payload: GeneratedPdfModel }>(),
);

// Common failure action for any PDF‑related HTTP errors
export const httpFail = createAction('[Pdf] Http Fail', props<{ payload: string }>());
